import { makeDraggable } from "../helpers/makeDraggable";
// import { draggableIcon } from "../markup/draggableIcon";
// import { destroyButton } from "../markup/destroyButton";

/**
 * Initializes an HTMX repeater with the given name.
 * @param {string} repeaterName - The name of the repeater to initialize.
 * @returns {Object} An object with a function to add a repeater item.
 */
export function initRepeaterHtmx(repeaterName) {
    let uniqueIdCounter = 0;
    const repeaterIs = `[data-repeater='${repeaterName}']`;

    // Setup the button that adds items
    const repeaterAddButton = document.querySelector(
        `${repeaterIs} .repeaterAdd button`,
    );

    // Define the relevant HTMX attributes
    repeaterAddButton.setAttribute(
        "hx-get",
        `/htmx_${repeaterName}Repeater.html`,
    );
    repeaterAddButton.setAttribute("hx-target", `${repeaterIs} .repeaterCont`);
    repeaterAddButton.setAttribute("hx-swap", "beforeend");

    /**
     * Adds a new item to the repeater.
     * @param {Event} event - The event that triggered the addition of the item.
     */
    function addRepeaterItem(event) {
        const targetElement = event.target;
        // Check if the event target is within the current repeater
        if (targetElement.closest(repeaterIs)) {
            const newItem = targetElement.lastElementChild;
            if (newItem) {
                uniqueIdCounter++;
                // console.log(`UID: ${uniqueIdCounter}`);
                newItem.id = `${repeaterName}_` + uniqueIdCounter;
                // console.log(newItem.id);
                makeDraggable(newItem);
                // draggableIcon(newItem);
                // destroyButton(newItem);
            }
        }
    }

    document.body.addEventListener("htmx:afterSwap", addRepeaterItem);

    return {
        addRepeaterItem,
    };
}

// import { makeDraggable } from "../helpers/makeDraggable";
// import { draggableIcon } from "../markup/draggableIcon";
// import { destroyButton } from "../markup/destroyButton";

// export function initRepeaterHtmx(repeaterName) {
//     let uniqueIdCounter = 0;
//     const repeaterIs = `[data-repeater='${repeaterName}']`;

//     // Setup the button that adds items
//     const repeaterAddButton = document.querySelector(
//         `${repeaterIs} .repeaterAdd button`,
//     );

//     // Define the relevant HTMX attributes
//     repeaterAddButton.setAttribute(
//         "hx-get",
//         `/htmx_${repeaterName}Repeater.html`,
//     );
//     repeaterAddButton.setAttribute("hx-target", `${repeaterIs} .repeaterCont`);
//     repeaterAddButton.setAttribute("hx-swap", "beforeend");
//     repeaterAddButton.setAttribute("data-action", "addRepeater"); // Add this line

//     function addRepeaterItem(event) {
//         // Check if the event was triggered by the 'addRepeater' action
//         if (event.detail.elt.getAttribute("data-action") === "addRepeater") {
//             const targetElement = event.target;
//             if (targetElement.closest(repeaterIs)) {
//                 const newItem = targetElement.lastElementChild;
//                 if (newItem) {
//                     uniqueIdCounter++;
//                     newItem.id = `${repeaterName}_` + uniqueIdCounter;
//                     makeDraggable(newItem);
//                     draggableIcon(newItem);
//                     destroyButton(newItem);
//                 }
//             }
//         }
//     }

//     // Attach the event listener to the body
//     // document.body.addEventListener("htmx:afterSwap", addRepeaterItem);
//     // Find the specific repeater container
//     const repeaterContainer = document.querySelector(
//         `${repeaterIs} .repeaterCont`,
//     );

//     // Attach the event listener to the specific repeater container
//     repeaterContainer.addEventListener("htmx:afterSwap", addRepeaterItem);

//     return {
//         addRepeaterItem,
//     };
// }
